import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { linkUnderline } from 'chaoskit/src/assets/styles/utility/link'

import Author from '../../global/Author'

import Data from '~components/Data'
import Link from '~components/Link'
import ButtonLink from '~components/ButtonLink'
import Image from '~components/Image'
import chaosEngineeringIcon from '~media/community/icon-chaos-engineering.svg'
import gamedaysIcon from '~media/community/icon-gamedays.svg'
import sreIcon from '~media/community/icon-sre.svg'

export function getTutorialCategory(categories) {
  // We're only going to display the first category chosen in the teaser
  const [category] = categories

  if (category === 'Chaos Engineering') {
    return {
      label: category,
      icon: chaosEngineeringIcon,
    }
  }

  if (category === 'GameDays') {
    return {
      label: category,
      icon: gamedaysIcon,
    }
  }

  if (category === 'SRE') {
    return {
      label: category,
      icon: sreIcon,
    }
  }

  return {}
}

const TutorialTeaser = ({
  title,
  author,
  authorUrl,
  excerpt,
  link,
  categories,
}) => {
  const theme = useTheme()

  const categoryMeta = getTutorialCategory(categories)

  return (
    <article
      css={{
        position: 'relative',
        border: `1px solid ${theme.brand.stone250}`,
        borderRadius: theme.borderRadius.base,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div css={{ padding: theme.space.base }}>
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: theme.space.small,
          }}
        >
          {categoryMeta.icon && (
            <Image
              src={categoryMeta.icon}
              alt={categoryMeta.label}
              css={{
                height: theme.height.xsmall,
              }}
            />
          )}
          <div
            css={{
              textAlign: 'right',
            }}
          >
            <ButtonLink
              url={link}
              size="xsmall"
              type="primary"
              css={{
                transformOrigin: 'center center',

                '&:hover, &:focus': {
                  transform: 'scale(1.05)',
                },
              }}
            >
              Start
            </ButtonLink>
          </div>
        </div>
        <div
          css={{
            marginTop: theme.space.base,
            ...theme.text.large,
            fontWeight: theme.fontWeight.bold,
          }}
        >
          <Link
            css={[
              linkUnderline,
              {
                color: theme.fontColor.base,

                '&:hover, &:focus': {
                  color: theme.fontColor.base,
                },
              },
            ]}
            to={link}
          >
            {typeof title === 'string' ? <Data>{title}</Data> : title}
          </Link>
        </div>
        <div css={{ ...theme.text.small, marginTop: theme.space.base }}>
          {typeof excerpt === 'string' ? <Data>{excerpt}</Data> : excerpt}
        </div>
      </div>
      <Author
        name={author}
        url={authorUrl}
        css={{
          paddingRight: theme.space.base,
          paddingBottom: theme.space.base,
          paddingLeft: theme.space.base,
        }}
      />
    </article>
  )
}

TutorialTeaser.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  author: PropTypes.string,
  authorUrl: PropTypes.string,
  excerpt: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  link: PropTypes.string.isRequired,
  categories: PropTypes.array.isRequired,
}

export default TutorialTeaser
